import { PageContainer } from '@components/Layout/PageContainer';
import { PageTitle } from '@components/Layout/PageTitle';
import { Business } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { TenantsTable } from '../components/TenantsTable';

export const TenantsPage = () => {
  const { formatMessage } = useIntl();


  return <>
    <PageTitle
      icon={<Business />}
      title={formatMessage({ id: 'Tenants' })}
      backgroundColor='secondary'
    />

    <PageContainer>
      <TenantsTable />
    </PageContainer>

  </>;
};